angular.module('tradersyard').controller('message-query-ctrl', [
    '$rootScope',
    '$scope',
    'graph-message-factory',
    '$flex',
    '$flex.array',
    function ($scope, $factory, $flex, $array) {
        $scope.node = undefined;
        $scope.nodes = [];
        $scope.params = {
            page: 0,
        };

        $scope.query = function (next) {
            ++$scope.params.page;
            $factory
                .entry($scope.node.id)
                .query({ params: $scope.params })
                .then(function (response) {
                    if (response.data.state === 0 && response.data.data.length > 0) {
                        $scope.nodes = $scope.nodes.concat(response.data.data);

                        if (next) next();
                    }
                });
        };

        $scope.delete = function (node) {
            $factory
                .entry($scope.node.id)
                .delete(node.id)
                .then(function (response) {
                    if (response.data.state === 0) {
                        $scope.nodes = $array.$splice($scope.nodes, node, 'id');
                    }
                });
        };

        $scope.$on('message-query-init', function (e, node) {
            if ($scope.node && node.id === $scope.node.id) return;

            $scope.node = node;
            $scope.nodes = [];
            $scope.params.page = 0;
            $flex.$scroll.renew('message');
            $scope.query();
        });

        $scope.$on('touch:message', function () {
            $scope.query();
            $flex.$scroll.switch('message');
        });
    },
]);
